"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[14249,12274],{

/***/ 982226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(640128);
/* harmony import */ var _Grid_constant_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(208984);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19840);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  padding-right: 16px;
  padding-left: 16px;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  @media (min-width: ${_Grid_constant_es_js__WEBPACK_IMPORTED_MODULE_2__/* .BREAK_POINTS.xl */ .d.xl}) {
    width: ${(props) => props.fluid ? "100%" : (0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .pixelParse */ .oJ)(props.maxWidth || "")};
  }
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .CommonStyles */ .F}
`;
const Container = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
  const _a = props, { children, fluid = false, maxWidth = 1232 } = _a, others = __objRest(_a, ["children", "fluid", "maxWidth"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    maxWidth,
    fluid,
    ref
  }, others), children);
});
Container.displayName = "Container";




/***/ }),

/***/ 816519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ Glide; }
/* harmony export */ });
/* harmony import */ var _glidejs_glide__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(490400);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(593859);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Glide = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((_a, ref) => {
  var _b = _a, {
    className,
    children,
    onSlideChange,
    style,
    showControl = true,
    showBullet = false,
    trackingArrowRight,
    trackingArrowLeft,
    customStyleLeftArrow,
    customStyleRightArrow,
    displayNewLayout
  } = _b, glideOpts = __objRest(_b, [
    "className",
    "children",
    "onSlideChange",
    "style",
    "showControl",
    "showBullet",
    "trackingArrowRight",
    "trackingArrowLeft",
    "customStyleLeftArrow",
    "customStyleRightArrow",
    "displayNewLayout"
  ]);
  const newRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  const childRefs = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)([]);
  const chooseRef = ref || newRef;
  const opts = __spreadValues(__spreadValues({}, defaultGlideOptions), glideOpts);
  if (children.length === 1) {
    opts.autoplay = false;
    showBullet = false;
    showControl = false;
  }
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (typeof chooseRef === "function" || !chooseRef.current)
      return;
    const controller = new _glidejs_glide__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(chooseRef.current, opts);
    let mounted;
    if (onSlideChange) {
      controller.on("move.after", () => {
        mounted && onSlideChange(mounted.index);
      });
    }
    (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .scheduleTaskInIdleTime */ .D_)(() => {
      mounted = controller.mount();
      children.length === 1 && (mounted == null ? void 0 : mounted.disable());
      if (chooseRef.current) {
        chooseRef.current.glide = mounted;
      }
    }, 3e3);
    return () => mounted == null ? void 0 : mounted.destroy();
  }, [children.length]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(Wrapper, {
    ref: chooseRef,
    className: `${className || ""} glide`,
    style,
    displayNewLayout
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "glide__track",
    "data-glide-el": "track"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "glide__slides"
  }, react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, (child, index) => {
    var _a2, _b2, _c;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
      ref: (e) => childRefs.current[index] = e,
      key: child.key || index,
      className: "glide__slide",
      style: {
        height: "unset",
        marginRight: index < children.length - 1 ? ((_a2 = childRefs.current[index]) == null ? void 0 : _a2.style.marginRight) || 5 : 0,
        marginLeft: index > 0 ? ((_b2 = childRefs.current[index]) == null ? void 0 : _b2.style.marginLeft) || 5 : 0,
        width: ((_c = childRefs.current) == null ? void 0 : _c[0]) ? childRefs.current[0].style.width : `calc(100% / ${opts.perView} - 8px) `
      }
    }, child);
  }))), showControl && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    "data-glide-el": "controls",
    className: "glide__arrows"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", __spreadValues({
    className: "glide__arrow--override glide__arrow--left",
    "data-glide-dir": `${opts.perSwipe ? "|" : ""}<`,
    style: customStyleLeftArrow
  }, trackingArrowLeft)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", __spreadValues({
    className: "glide__arrow--override glide__arrow--right",
    "data-glide-dir": `${opts.perSwipe ? "|" : ""}>`,
    style: customStyleRightArrow
  }, trackingArrowRight))), showBullet && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "glide__bullets glide__bullets--override",
    "data-glide-el": "controls[nav]"
  }, react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, (_, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("button", {
    className: "glide__bullet",
    key: index,
    "data-glide-dir": `=${index}`
  }))));
});
Glide.displayName = "Glide";
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"].div((props) => `
  &:hover {
    .glide__arrow--override {
      visibility: visible;
    }
  }

  .glide__track {
    overflow: hidden;
    position: relative;
    height: 100%;
  }
  .glide__slides {
    height: 100%;
  }
  .glide__arrow--override {
    position: absolute;
    left: 0;
    top: 50%;
    z-index: 10;
    cursor: pointer;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    transform: translateY(-50%);
    background-color: rgba(168, 168, 168, 0.46);
    visibility: hidden;
  }

  .glide__arrow--left {
    right: auto;
    left: 0;
    border-top-right-radius: 100px;
    border-bottom-right-radius: 100px;

    &:after {
      mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
      content: ' ';
      height: 30px;
      width: 30px;
      mask-size: contain;
      display: inline-block;
      background: #333;
    }
  }

  .glide__arrow--right {
    right: 0;
    left: auto;
    border-top-left-radius: 100px;
    border-bottom-left-radius: 100px;

    &:after {
      mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
      content: ' ';
      height: 30px;
      width: 30px;
      mask-size: contain;
      display: inline-block;
      background: #333;
    }
  }

  ${props.displayNewLayout ? `.glide__arrow--override {
    visibility: visible;
    width: 28px;
    height: 28px;
  }
  .horizontal-slider,
  .glide__track {
    margin: 0 auto;
    background-color: white;
  }
  .glide__slides {
    margin: 0 auto;
  }
  .glide__arrow--left {
    left: 8px !important;
    border-radius: 100px;
    background-color: #fff !important;
    box-shadow: -1px 4px 5px 2px rgba(0, 0, 0, 0.12);
    &:after {
      height: 14px !important;
      width: 14px !important;
      box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05);
      box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
      box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08);
    }
  }
  .glide__arrow--right {
    right: 8px !important;
    border-radius: 100px;
    background-color: #fff !important;
    box-shadow: -1px 4px 5px 2px rgba(0, 0, 0, 0.12);
    &:after {
      height: 14px !important;
      width: 14px !important;
      box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05);
      box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
      box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08);
    }
  }` : ``}
`);
const defaultGlideOptions = {
  type: "slider",
  startAt: 0,
  perView: 2.3,
  perSwipe: "",
  focusAt: 0,
  gap: 10,
  autoplay: false,
  hoverpause: true,
  keyboard: true,
  bound: false,
  swipeThreshold: 80,
  dragThreshold: 120,
  perTouch: false,
  touchRatio: 0.5,
  touchAngle: 45,
  animationDuration: 400,
  rewind: false,
  rewindDuration: 800,
  animationTimingFunc: "cubic-bezier(0.165, 0.840, 0.440, 1.000)",
  direction: "ltr",
  peek: 0,
  breakpoints: {},
  throttle: 25
};




/***/ }),

/***/ 248169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ InputNumber; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var rc_input_number__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(241305);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(994734);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(925810);
/* harmony import */ var _Shape_index_es_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(425336);
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(978719);
/* harmony import */ var _contexts_SizeContext_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(263008);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);









var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SAVED_DECIMAL_SEPARATOR = ".";
const InputNumber = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_a, ref) => {
  var _b = _a, {
    size: customizeSize,
    addonBefore,
    addonAfter,
    bordered = true,
    disabled = false,
    readOnly = false,
    formatter,
    parser
  } = _b, props = __objRest(_b, [
    "size",
    "addonBefore",
    "addonAfter",
    "bordered",
    "disabled",
    "readOnly",
    "formatter",
    "parser"
  ]);
  var _a2, _b2;
  const size = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_contexts_SizeContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* .SizeContext */ .X);
  const mergeSize = customizeSize || size || "m";
  const { decimalSeparator } = props;
  const defaultFormatter = (value) => {
    if (!value)
      return "";
    if (typeof value === "string") {
      value = parseFloat(value);
    }
    const locale = decimalSeparator === "." ? "en-CA" : "de-DE";
    return new Intl.NumberFormat(locale, {
      maximumFractionDigits: 10
    }).format(value);
  };
  const defaultParser = (value) => {
    if (!value) {
      return "";
    }
    const thousandSeparator = decimalSeparator === "." ? "," : ".";
    return value.replace(thousandSeparator, "").replace(decimalSeparator || ".", SAVED_DECIMAL_SEPARATOR);
  };
  const prefix = addonBefore ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSpace, {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .MAPPING_SIZE */ .v[mergeSize]
  }, typeof addonBefore === "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .uT, {
    color: "textSecondary",
    level: 1,
    weight: "regular"
  }, addonBefore) : react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(addonBefore, {
    size: ((_a2 = addonBefore == null ? void 0 : addonBefore.props) == null ? void 0 : _a2.size) || 20
  })) : null;
  const suffix = addonAfter ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSpace, {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .MAPPING_SIZE */ .v[mergeSize],
    marginLeft: "s16"
  }, typeof addonAfter === "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .uT, {
    color: "textSecondary",
    level: 1,
    weight: "regular"
  }, addonAfter) : react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(addonAfter, {
    size: ((_b2 = addonAfter == null ? void 0 : addonAfter.props) == null ? void 0 : _b2.size) || 20
  })) : null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .MAPPING_SIZE */ .v[mergeSize],
    disabled,
    readOnly,
    bordered,
    paddingRight: !!suffix ? "s16" : "s0",
    className: "wrap-input-number"
  }, prefix, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(rc_input_number__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, __spreadValues({
    ref,
    upHandler: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__/* .UpOutlined */ .X, {
      size: 12
    }),
    downHandler: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__/* .DownOutlined */ .T, {
      size: 12
    }),
    disabled,
    readOnly,
    formatter: formatter != null ? formatter : defaultFormatter,
    parser: parser != null ? parser : defaultParser
  }, props)), suffix);
});
InputNumber.displayName = "InputNumber";
const Wrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"])(_Shape_index_es_js__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b)(({ theme, disabled, readOnly, bordered }) => `
  ${disabled ? `background: ${theme == null ? void 0 : theme.colors.background}; 
         cursor: not-allowed;` : "background: white;"}
  ${bordered ? `border: 1px solid ${theme == null ? void 0 : theme.colors.border};
         border-radius: 4px;` : ""}
  &:focus-within{
    border-color: ${theme == null ? void 0 : theme.colors.link500};
  }
  display: flex;
  padding-left: 0.75rem;
  .rc-input-number {
      position: relative;
      flex: 1;
      padding: 0 1px;
      &:hover{
        .rc-input-number-handler-wrap{
            opacity: 1;
        }
      }
  }
  .rc-input-number-input-wrap{
      height: 100%;
      & input {
        width: 100%;
        height: 100%;
        outline: 0;
        border: 0;
        &::placeholder {
          color: ${theme == null ? void 0 : theme.colors.placeholder};
        }
        ${disabled ? "cursor: not-allowed;" : ""}
    }
  }
  .rc-input-number-handler-wrap{
      opacity: 0;
      transition: opacity 0.24s linear 0.1s;
      position: absolute;
      display: flex;
      flex-direction: column;
      justify-content: center;
      right: 0;
      line-height: 0;
      height: 100%;
      width: 25px;
      ${bordered ? `border-left: 1px solid ${theme == null ? void 0 : theme.colors.border};
             border-right: 1px solid ${theme == null ? void 0 : theme.colors.border};` : ""}
      ${disabled || readOnly ? "display: none;" : ""}
  }
  .rc-input-number-handler-up, 
  .rc-input-number-handler-down{
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &:hover path {
      stroke: ${theme == null ? void 0 : theme.colors.link500};
    }
  }
  .rc-input-number-handler-down {
    ${bordered ? `border-top: 1px solid ${theme == null ? void 0 : theme.colors.border};` : ""}
  }
  .rc-input-number-handler-up-disabled, 
  .rc-input-number-handler-down-disabled {
    cursor: not-allowed;
    background: ${theme == null ? void 0 : theme.colors.background};
    &:hover path {
      stroke: ${theme == null ? void 0 : theme.colors.textSecondary};
    }
  }
`);
const StyledSpace = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"])(_Shape_index_es_js__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b)`
  display: flex;
  align-items: center;
`;




/***/ }),

/***/ 280392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Quantity; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(978719);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(957518);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(873834);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(640128);
/* harmony import */ var _InputNumber_InputNumber_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(248169);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);







var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const QuantitySize = {
  xs: {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CORE_SIZE.s28 */ .y.s28,
    width: "5.75rem"
  },
  s: {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CORE_SIZE.s32 */ .y.s32,
    width: "6.375rem"
  },
  m: {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CORE_SIZE.s40 */ .y.s40,
    width: "6.375rem"
  }
};
const QuantityWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div((props) => {
  var _a, _b, _c, _d, _e, _f;
  return [
    _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .CommonStyles */ .F,
    `
  height: ${QuantitySize[props.size || "m"].height};
  width: ${props.block ? "100%" : QuantitySize[props.size || "m"].width};
  border-radius: ${(_a = props.theme) == null ? void 0 : _a.borderRadius.s};
  background: ${props.disabled ? (_b = props.theme) == null ? void 0 : _b.colors.background : (_c = props.theme) == null ? void 0 : _c.colors.tableHeader};
  ${!props.disabled ? `border: ${(_d = props.theme) == null ? void 0 : _d.borderWeight.m} solid ${((_e = props.theme) == null ? void 0 : _e.colors[props.color]) || ((_f = props.theme) == null ? void 0 : _f.colors.divider)};` : ""}
  display: flex;
  align-items: center;
  overflow: hidden;
`
  ];
});
const Plus = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].button(({ disabled }) => `
    height: 100%;
    width: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    user-select: none;
    border: none;
    background: transparent;
    &:focus {
      outline: none;
    }
    ${disabled ? "cursor: not-allowed;" : ""}
`);
const Minus = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].button(({ disabled }) => `
    height: 100%;
    width: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    user-select: none;
    border: none;
    background: transparent;
    &:focus {
      outline: none;
    }
    ${disabled ? "cursor: not-allowed;" : ""}
`);
const InputWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ color, theme }) => `
  flex: 1;
  .wrap-input-number {
    padding: 0;
    border: none;
    background-color: transparent;
  }
  .wrap-input-number input {
    text-align: center;
    background-color: transparent;
    font-size: 0.8125rem;
    font-weight: 500;
    color: ${color ? (theme == null ? void 0 : theme.colors[color]) || color : "rgb(67, 70, 87)"};
  }
`);
const IconButonWapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].span`
  display: inline-flex;
  align-items: center;
`;
const Quantity = (_a) => {
  var _b = _a, {
    min = 1,
    max = 999,
    quantity = 1,
    precision,
    decimalSeparator = ",",
    step = 1,
    size = "s",
    disabled,
    disableInput,
    disableMinus,
    disablePlus,
    className,
    onMinus,
    onPlus,
    setQuantity,
    color,
    block,
    blurOnEnter = false,
    formatter,
    parser
  } = _b, rest = __objRest(_b, [
    "min",
    "max",
    "quantity",
    "precision",
    "decimalSeparator",
    "step",
    "size",
    "disabled",
    "disableInput",
    "disableMinus",
    "disablePlus",
    "className",
    "onMinus",
    "onPlus",
    "setQuantity",
    "color",
    "block",
    "blurOnEnter",
    "formatter",
    "parser"
  ]);
  const inputRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const onChange = (val) => {
    if (typeof val === "string") {
      val = parseFloat(val);
    }
    if (typeof val !== "number") {
      return;
    }
    setQuantity == null ? void 0 : setQuantity(val);
  };
  const onDecrease = () => {
    if (onMinus) {
      onMinus();
    } else if (step) {
      setQuantity == null ? void 0 : setQuantity(quantity - step);
    }
  };
  const onIncrease = () => {
    if (onPlus) {
      onPlus();
    } else if (step) {
      setQuantity == null ? void 0 : setQuantity(quantity + step);
    }
  };
  const disableMinusButton = disabled || disableMinus || quantity - step < min;
  const disablePlusButton = disabled || disablePlus || quantity + step > max;
  const disableInputField = disabled || disableInput;
  const handleBlurOnEnter = (e) => {
    var _a2;
    const ENTER_CHAR_CODE = 13;
    if (e.charCode === ENTER_CHAR_CODE) {
      (_a2 = inputRef.current) == null ? void 0 : _a2.blur();
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const current = inputRef.current;
    if (blurOnEnter) {
      current == null ? void 0 : current.addEventListener("keypress", handleBlurOnEnter);
    }
    return () => {
      current == null ? void 0 : current.removeEventListener("keypress", handleBlurOnEnter);
    };
  }, [blurOnEnter]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(QuantityWrapper, __spreadValues({
    className,
    size,
    block,
    disabled,
    color,
    onClick: (e) => e.preventDefault()
  }, rest), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Minus, {
    className: "minus-btn",
    disabled: disableMinusButton,
    onClick: onDecrease,
    color
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconButonWapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .MinusOutlined */ .l, {
    color: disableMinusButton ? "disable" : color || "textPrimary",
    size: 16
  }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(InputWrapper, {
    className: "quantity-input-wrapper",
    color
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_InputNumber_InputNumber_es_js__WEBPACK_IMPORTED_MODULE_5__/* .InputNumber */ .R, {
    ref: inputRef,
    value: quantity,
    onFocus: (event) => event.target.select(),
    onChange,
    disabled: disableInputField,
    controls: false,
    min,
    max,
    step,
    precision,
    decimalSeparator,
    formatter,
    parser
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Plus, {
    className: "plus-btn",
    disabled: disablePlusButton,
    onClick: onIncrease,
    color
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconButonWapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__/* .AddOutlined */ .v, {
    color: disablePlusButton ? "disable" : color || "textPrimary",
    size: 16
  }))));
};




/***/ }),

/***/ 991822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ Tag; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(621655);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MAPPING_COLOR_500 = {
  branding: "primary500",
  link: "link500",
  success: "success500",
  error: "error500",
  pending: "pending500"
};
const MAPPING_COLOR_600 = {
  branding: "primary600",
  link: "link600",
  success: "success600",
  error: "error600",
  pending: "pending600"
};
const MAPPING_COLOR_50 = {
  branding: "primary50",
  link: "link50",
  success: "success50",
  error: "error50",
  pending: "pending50"
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].span`
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
  display: inline-flex;
  align-items: center;
  padding-left: ${(p) => p.theme.spacing.s4};
  padding-right: ${(p) => p.theme.spacing.s4};
  height: 1rem;
  border-radius: ${(p) => p.theme.borderRadius.s};
  border: ${(p) => p.borderColor ? `${p.theme.borderWeight.m} solid ${p.theme.colors[p.borderColor]}` : "unset"};
  background-color: ${(p) => p.theme.colors[p.backgroundColor]};
`;
const Tag = (_a) => {
  var _b = _a, {
    variant = "branding",
    type = "primary",
    content,
    className
  } = _b, rest = __objRest(_b, [
    "variant",
    "type",
    "content",
    "className"
  ]);
  const getBgColor = () => {
    if (type === "primary") {
      if (variant === "default")
        return "white";
      return MAPPING_COLOR_500[variant];
    }
    if (type === "secondary") {
      if (variant === "default")
        return "background";
      return MAPPING_COLOR_50[variant];
    }
    if (type === "ghost") {
      return "white";
    }
  };
  const getBorderColor = () => {
    if (type === "ghost") {
      if (variant === "default")
        return "border";
      return MAPPING_COLOR_600[variant];
    }
  };
  const getColor = () => {
    if (variant === "default")
      return "textPrimary";
    if (type === "primary")
      return "white";
    return MAPPING_COLOR_600[variant];
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    backgroundColor: getBgColor() || "",
    borderColor: getBorderColor(),
    className
  }, rest), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Caption */ .YS, {
    color: getColor(),
    level: 3,
    weight: "medium",
    line: 1
  }, content));
};




/***/ }),

/***/ 873834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ AddOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const AddOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.75 4C12.75 3.58579 12.4142 3.25 12 3.25C11.5858 3.25 11.25 3.58579 11.25 4V11.25H4C3.58579 11.25 3.25 11.5858 3.25 12C3.25 12.4142 3.58579 12.75 4 12.75H11.25V20C11.25 20.4142 11.5858 20.75 12 20.75C12.4142 20.75 12.75 20.4142 12.75 20V12.75H20C20.4142 12.75 20.75 12.4142 20.75 12C20.75 11.5858 20.4142 11.25 20 11.25H12.75V4Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 925810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ DownOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const DownOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M5 8.5L12 15.5L19 8.5",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 203494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ RightOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const RightOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M8.49976 19.0001L15.4998 12.0001L8.49976 5.00012",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 994734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ UpOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const UpOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M19 15.5L12 8.5L5 15.5",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 842918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ BlockHeader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(618428);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(621655);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29921);
/* harmony import */ var _contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(917709);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const RightOutlined = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => Promise.all(/* import() */[__webpack_require__.e(10433), __webpack_require__.e(27477), __webpack_require__.e(64871), __webpack_require__.e(80710)]).then(__webpack_require__.bind(__webpack_require__, 564871)).then((mod) => mod.RightOutlined));
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].div(({
  isMobile,
  theme,
  backgroundColor
}) => `
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${!isMobile ? `
          padding-left: ${theme.spacing.s16};
          padding-right: ${theme.spacing.s16};
          ` : ""}
  height: ${isMobile ? "2.75rem" : "3.5rem"};
  background-color: ${backgroundColor};
`);
const SeeAll = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].div(({ theme, color }) => `
    cursor: pointer;
    color: ${theme.colors[color] || theme.colors.textSecondary};
`);
const BlockHeader = ({
  title,
  titleColor,
  link,
  backgroundColor = "unset",
  tracking,
  className,
  style
}) => {
  const { isMobile } = (0,_contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* .useDevice */ .F)();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    className,
    isMobile,
    backgroundColor,
    style
  }, link ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .CustomLink */ .x, __spreadValues({}, link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Title */ .Dx, {
    color: titleColor || "textTitle",
    className: "title"
  }, title)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .CustomLink */ .x, __spreadValues({}, link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SeeAll, __spreadValues({
    color: link.color || ""
  }, tracking), (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_6__.t)("Xem t\u1EA5t c\u1EA3"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(RightOutlined, {
    color: link.color
  })))) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Title */ .Dx, {
    color: titleColor || "textTitle",
    className: "title"
  }, title));
};




/***/ }),

/***/ 788925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ EnhancedImage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(587021);
/* harmony import */ var _TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(675601);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const EnhancedImage = (props) => {
  const _a = props, { link, tracking } = _a, rest = __objRest(_a, ["link", "tracking"]);
  const img = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .E, __spreadValues(__spreadValues({}, rest), !!tracking ? { tracking } : {}));
  return (link == null ? void 0 : link.href) ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__/* .TekoLink */ .A, __spreadValues({}, link), img) : img;
};




/***/ }),

/***/ 784241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ HorizontalSlider; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const HorizontalSlider = (_a) => {
  var _b = _a, {
    slidesPerView,
    children
  } = _b, props = __objRest(_b, [
    "slidesPerView",
    "children"
  ]);
  if (!Array.isArray(children)) {
    return null;
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), Array.isArray(children) && children.map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Item, {
    slidesPerView,
    key: index
  }, item)));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].div(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F, () => `
  display: flex;
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  };
  transform: translate3d(0,0,0);
  `);
const Item = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].div((props) => {
  var _a;
  return `
    width: ${100 / ((_a = props.slidesPerView) != null ? _a : 1)}%;
    flex-shrink: 0;
    margin-right: 8px;
  `;
});




/***/ }),

/***/ 414562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ ProductCarousel; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(816519);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(212951);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77322);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(428247);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _HorizontalSlider_HorizontalSlider_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(784241);
/* harmony import */ var _contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(917709);
/* harmony import */ var _ProductCard_ProductCard_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(922859);







var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ProductCarousel = (_a) => {
  var _b = _a, {
    products = [],
    productsPerRow,
    className,
    regionName,
    hideCtaButton,
    border,
    customStyleLeftArrow,
    customStyleRightArrow,
    desktopProps
  } = _b, props = __objRest(_b, [
    "products",
    "productsPerRow",
    "className",
    "regionName",
    "hideCtaButton",
    "border",
    "customStyleLeftArrow",
    "customStyleRightArrow",
    "desktopProps"
  ]);
  const { isMobile } = (0,_contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__/* .useDevice */ .F)();
  const trackViewProductListData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    return products.map((product) => {
      var _a2, _b2;
      return {
        sku: product.sku || "",
        category: ((_b2 = (_a2 = product.categories) == null ? void 0 : _a2[0]) == null ? void 0 : _b2.name) || ""
      };
    });
  }, [products]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (trackViewProductListData.length > 0) {
      (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_2__/* .trackViewProductList */ .u)(trackViewProductListData);
    }
  }, [JSON.stringify(trackViewProductListData)]);
  if (isMobile) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "wrapper-horizontal-slider"
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_HorizontalSlider_HorizontalSlider_es_js__WEBPACK_IMPORTED_MODULE_3__/* .HorizontalSlider */ .r, {
      slidesPerView: productsPerRow || 2.3,
      className: "horizontal-slider"
    }, products.map((product, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCard, {
      key: product.sku,
      border: !!border
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ProductCard_ProductCard_es_js__WEBPACK_IMPORTED_MODULE_4__/* .ProductCard */ .I, __spreadProps(__spreadValues({}, product), {
      tracking: regionName ? (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .getTrackingData */ .O5)({
        regionName,
        isTrackContent: true,
        contentName: product.sku,
        target: "productDetail",
        index: index + 1,
        payload: product.bestComboDiscount && Number(product.bestComboDiscount) !== 0 ? JSON.stringify({ promotionType: "combo" }) : void 0
      }) : {},
      addToCart: hideCtaButton ? void 0 : product.addToCart
    }))))));
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Glide */ .A, __spreadValues(__spreadProps(__spreadValues({
    perView: productsPerRow || 5,
    perSwipe: "|",
    className,
    customStyleLeftArrow,
    customStyleRightArrow
  }, props), {
    showControl: products.length > (productsPerRow || 5),
    swipeThreshold: products.length > (productsPerRow || 5),
    dragThreshold: products.length > (productsPerRow || 5)
  }), desktopProps), products.map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCard, {
    key: item.sku,
    border: !!border
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ProductCard_ProductCard_es_js__WEBPACK_IMPORTED_MODULE_4__/* .ProductCard */ .I, __spreadProps(__spreadValues({}, item), {
    tracking: (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .getTrackingData */ .O5)({
      regionName,
      isTrackContent: true,
      contentName: item.sku,
      target: "productDetail",
      index: index + 1,
      payload: item.bestComboDiscount && Number(item.bestComboDiscount) !== 0 ? JSON.stringify({ promotionType: "combo" }) : void 0
    }),
    addToCart: hideCtaButton ? void 0 : item.addToCart
  })))));
};
const Card = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__["default"].div`
  background: white;
  border-radius: 0.5rem;
`;
const StyledCard = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__["default"])(Card)(({ theme, border }) => __spreadValues({
  height: "100%"
}, border ? {
  border: "1px solid",
  borderColor: theme.colors.divider,
  borderRadius: theme.spacing.s8,
  overflow: "hidden"
} : {}));




/***/ }),

/***/ 591007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ ProductPrice; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(212951);
/* harmony import */ var _helpers_number_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54230);




const isShowRetailPrice = (supplierRetailPrice, latestPrice) => {
  let newSupplierRetailPrice = supplierRetailPrice;
  let newLatestPrice = latestPrice;
  if (typeof supplierRetailPrice === "string") {
    newSupplierRetailPrice = supplierRetailPrice.replace(/[₫đ.]/g, "");
  }
  if (typeof latestPrice === "string") {
    newLatestPrice = latestPrice.replace(/[₫đ.]/g, "");
  }
  return Number(newSupplierRetailPrice) > Number(newLatestPrice);
};
const ProductPrice = ({
  supplierRetailPrice,
  latestPrice,
  discountPercent,
  textColor = "primary500",
  align = "start",
  size = "m",
  className,
  priceRange,
  numberDisplayFormat
}) => {
  const formattedRetailPrice = typeof supplierRetailPrice === "number" ? (0,_helpers_number_es_js__WEBPACK_IMPORTED_MODULE_1__/* .formatCurrency */ .xG)(supplierRetailPrice, numberDisplayFormat) : supplierRetailPrice;
  const formattedLatestPrice = typeof latestPrice === "number" ? (0,_helpers_number_es_js__WEBPACK_IMPORTED_MODULE_1__/* .formatCurrency */ .xG)(latestPrice, numberDisplayFormat) : latestPrice;
  let renderedRetailPrice, renderedDiscount;
  const renderedLatestPrice = () => {
    if (!priceRange) {
      return size === "l" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx, {
        className: "att-product-detail-latest-price",
        level: 2,
        color: textColor,
        weight: "bold"
      }, formattedLatestPrice) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK, {
        className: "att-product-detail-latest-price",
        level: 1,
        color: textColor
      }, formattedLatestPrice);
    }
    const formattedMinPrice = (0,_helpers_number_es_js__WEBPACK_IMPORTED_MODULE_1__/* .formatCurrency */ .xG)(priceRange.min, numberDisplayFormat, false);
    const formattedMaxPrice = (0,_helpers_number_es_js__WEBPACK_IMPORTED_MODULE_1__/* .formatCurrency */ .xG)(priceRange.max, numberDisplayFormat);
    return size === "l" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledTitle, {
      level: 2,
      color: textColor,
      weight: "bold",
      line: 1
    }, formattedMinPrice, " - ", formattedMaxPrice) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSubTitle, {
      level: 1,
      color: textColor,
      line: 1
    }, formattedMinPrice, " - ", formattedMaxPrice);
  };
  switch (size) {
    case "l":
      renderedRetailPrice = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledRetailPrice, {
        className: "att-product-detail-retail-price",
        level: 1,
        color: "textSecondary"
      }, formattedRetailPrice);
      renderedDiscount = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Caption */ .YS, {
        level: 1,
        color: "red"
      }, discountPercent);
      break;
    default:
      renderedRetailPrice = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledRetailPrice, {
        className: "att-product-detail-retail-price",
        level: 1,
        color: "textSecondary"
      }, formattedRetailPrice);
      renderedDiscount = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Caption */ .YS, {
        level: 1,
        color: "red"
      }, discountPercent);
      break;
  }
  const showRetailPrice = supplierRetailPrice && isShowRetailPrice(supplierRetailPrice, latestPrice);
  const isShowDiscount = !!discountPercent;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ProductPriceWrapper, {
    align,
    className
  }, renderedLatestPrice(), (showRetailPrice || isShowDiscount) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledDiscount, null, showRetailPrice && renderedRetailPrice, isShowDiscount && renderedDiscount));
};
const ProductPriceWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div(({ align }) => `
  display: flex;
  flex-direction: column;
  align-items: ${align};
  height: 2.5rem;
`);
const StyledRetailPrice = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Caption */ .YS)(({ theme }) => `
    text-decoration: line-through;
    margin-right: ${theme == null ? void 0 : theme.spacing.s4};
`);
const StyledDiscount = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  display: flex;
  height: 1rem;
`;
const StyledTitle = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx)`
  word-break: break-all;
`;
const StyledSubTitle = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK)`
  word-break: break-all;
`;




/***/ }),

/***/ 675601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ TekoLink; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(535874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(640128);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(456933);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(987900);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const serverless = typeof window !== "undefined";
const normalizeUrl = (url) => {
  if (!serverless || !url || typeof url !== "string")
    return url;
  if (url.match(/^https?:\/\/([^/]+)/)) {
    const urlObj = new URL(url);
    if (urlObj.hostname === window.location.host) {
      return `${urlObj.pathname}${urlObj.search}`;
    }
  }
  return url;
};
const TekoLink = (_a) => {
  var _b = _a, {
    children,
    href,
    as,
    prefetch = false
  } = _b, rest = __objRest(_b, [
    "children",
    "href",
    "as",
    "prefetch"
  ]);
  const [newState, setNewState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    pathname: (typeof href === "string" ? href : href == null ? void 0 : href.pathname) || "",
    query: {},
    as
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    async function init() {
      if (!href)
        return;
      href = normalizeUrl(href);
      as = normalizeUrl(as);
      if (typeof href === "string") {
        const result = await (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .resolveTekoPathname */ .K)((0,_teko_utils__WEBPACK_IMPORTED_MODULE_4__/* .getUrlObject */ .Bi)(href));
        if (!result.pathname) {
          result.pathname = href;
        }
        setNewState(__spreadProps(__spreadValues({}, result), { as: as || href }));
      } else {
        const result = await (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .resolveTekoPathname */ .K)(href);
        if (!result.pathname && (href == null ? void 0 : href.pathname)) {
          result.pathname = href.pathname;
        }
        setNewState(__spreadProps(__spreadValues(__spreadValues({}, href), result), {
          as: as || ((href == null ? void 0 : href.pathname) ? href : null) || void 0
        }));
      }
    }
    init();
  }, [href, as, setNewState]);
  if (!href) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
  }
  if (serverless) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledLink, __spreadValues({
      "data-testid": "TekoLink",
      href: { pathname: newState.pathname, query: newState.query },
      as: newState.as,
      prefetch
    }, rest), children);
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledLink, __spreadProps(__spreadValues({
    "data-testid": "TekoLink",
    href: href || "",
    as
  }, rest), {
    prefetch
  }), children);
};
const StyledLink = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"])((next_link__WEBPACK_IMPORTED_MODULE_1___default()))`
  ${_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .CommonStyles */ .F}
  color: black;
  text-decoration: none;
`;




/***/ }),

/***/ 875547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ok": function() { return /* binding */ SOURCE_VIDEO; },
/* harmony export */   "bM": function() { return /* binding */ defaultSlider; },
/* harmony export */   "n6": function() { return /* binding */ DEFAULT_NUMBER_DISPLAY_FORMAT; }
/* harmony export */ });
const defaultSlider = {
  perView: 5,
  perSwipe: "|",
  autoplay: 0
};
const DEFAULT_NUMBER_DISPLAY_FORMAT = {
  thousandSeparator: ".",
  decimalSeparator: ","
};
var SOURCE_VIDEO = /* @__PURE__ */ ((SOURCE_VIDEO2) => {
  SOURCE_VIDEO2["SYSTEM"] = "SYSTEM";
  SOURCE_VIDEO2["YOUTUBE"] = "YOUTUBE";
  return SOURCE_VIDEO2;
})(SOURCE_VIDEO || {});




/***/ }),

/***/ 54230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V2": function() { return /* binding */ numberFormatter; },
/* harmony export */   "kX": function() { return /* binding */ numberParser; },
/* harmony export */   "xG": function() { return /* binding */ formatCurrency; }
/* harmony export */ });
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(875547);


const formatCurrency = (value, numberDisplayFormat, includeUnit = true) => {
  if (typeof value !== "number")
    return "";
  let currencyFormat;
  if (includeUnit)
    currencyFormat = new Intl.NumberFormat("vi-VN", {
      style: "currency",
      currency: "VND"
    });
  else
    currencyFormat = new Intl.NumberFormat("vi-VN");
  const valueWithCurrency = currencyFormat.format(value);
  if (!!numberDisplayFormat) {
    return valueWithCurrency.replaceAll(".", numberDisplayFormat.thousandSeparator);
  } else {
    return valueWithCurrency;
  }
};
const numberFormatter = (value, numberDisplayFormat) => {
  const strValue = String(value);
  const [integerPart, decimalPart = ""] = strValue.split(".");
  return integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, (numberDisplayFormat == null ? void 0 : numberDisplayFormat.thousandSeparator) || _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_NUMBER_DISPLAY_FORMAT.thousandSeparator */ .n6.thousandSeparator) + (strValue.includes(".") ? `${(numberDisplayFormat == null ? void 0 : numberDisplayFormat.decimalSeparator) || _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_NUMBER_DISPLAY_FORMAT.decimalSeparator */ .n6.decimalSeparator}${decimalPart}` : "");
};
const numberParser = (value, numberDisplayFormat) => {
  return (numberDisplayFormat == null ? void 0 : numberDisplayFormat.decimalSeparator) === "." ? `${value}`.replace(new RegExp(`[^0-9-${(numberDisplayFormat == null ? void 0 : numberDisplayFormat.decimalSeparator) || _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_NUMBER_DISPLAY_FORMAT.decimalSeparator */ .n6.decimalSeparator}]`, "g"), "") : `${value}`.replace(new RegExp(`[^0-9-${(numberDisplayFormat == null ? void 0 : numberDisplayFormat.decimalSeparator) || _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_NUMBER_DISPLAY_FORMAT.decimalSeparator */ .n6.decimalSeparator}]`, "g"), "").replace(`${(numberDisplayFormat == null ? void 0 : numberDisplayFormat.decimalSeparator) || _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_NUMBER_DISPLAY_FORMAT.decimalSeparator */ .n6.decimalSeparator}`, ".");
};




/***/ }),

/***/ 29921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ NAMESPACE; },
  "K": function() { return /* binding */ lang; },
  "t": function() { return /* binding */ t; }
});

// EXTERNAL MODULE: ../../.yarn/cache/i18next-npm-21.4.0-68c8d0fefd-cd26c166df.zip/node_modules/i18next/dist/esm/i18next.js
var i18next = __webpack_require__(396556);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/lang/vi.es.js
var viLang = {
	"src.components.ProductCard.ProductCard.0": "Sản phẩm này là đồ uống có cồn, quý khách cần xác nhận mình trên 18 tuổi để mua sản phẩm!"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/lang/en.es.js
var enLang = {
	"Kết thúc sau": "End in",
	"ngày": "day",
	"Còn {{DurationDays}} ngày": "{{DurationDays}} days left",
	"Giảm trực tiếp": "Discount",
	"Tặng": "Receive",
	"GIẢM": "Decrease",
	"Không tìm thấy sản phẩm nào": "No product found",
	"Cảnh báo": "Warning",
	"src.components.ProductCard.ProductCard.0": "This is alcohol product, please confirm you are 18 years old to purchase!",
	"Tôi trên 18 tuổi": "I am over 18",
	"Tôi dưới 18 tuổi": "I am under 18",
	"Xác nhận": "Confirm",
	"TIẾT KIỆM": "Save",
	"Xem thêm": "Expand",
	"Thu gọn": "Collapse",
	"Bộ lọc đã dùng": "Used filter",
	"Xóa bộ lọc": "Clear filter",
	"Hàng trưng bày": "Sample",
	"Hàng đặt trước": "Pre-order",
	"Ngừng kinh doanh": "Stop selling",
	"Hàng quà tặng": "Gift",
	"Còn lại {{var0}}": "{{var0}} left",
	"Đã bán {{FlSaleUsedCount}}": "{{FlSaleUsedCount}} sold",
	"Hàng sắp về": "Coming soon",
	"Liên hệ": "Contact",
	"Còn {{stockQuantity}} sản phẩm": "{{stockQuantity}} left",
	"Xem tất cả": "View all",
	"Thương hiệu nổi bật": "Featured brands",
	"Danh mục sản phẩm": "Categories",
	"Sản phẩm dành cho bạn": "Products for you",
	"Chọn ngày nhận hàng": "Select delivery date",
	"Chọn khung giờ": "Select delivery time",
	"Tìm kiếm gần đây": "Recent search",
	"Chọn khu vực nhận hàng": "Select the location",
	"Vui lòng chọn khu vực nhận hàng của bạn": "Please select your location",
	"Tìm kiếm Tỉnh/ Thành phố": "Search Province/City",
	"Không tìm thấy tỉnh thành phố nào !!": "No provice/city is found !!",
	"Khi thay đổi thông tin đơn hàng thanh toán lại, đơn hiện tại sẽ bị hủy. Giá và khuyến mại đơn hàng có thể bị thay đổi. Bạn có chắc chắn muốn thực hiện thao tác này?": "When changing payment order information, current order will be canceled. Order prices and promotions are subject to change. Are you sure you want to perform this action?",
	"Trường hợp muốn thay đổi hình thức thanh toán hoặc các thông tin khác, vui lòng": "If you want to change your payment configuration or other information, please",
	"Bấm vào đây": "Click here",
	"Xem chi tiết": "View detail",
	"Cần thanh toán": "Need to pay",
	"Giao hàng bởi": "Delivered by",
	"Mã vận đơn": "Shipment code",
	"Cung cấp bởi": "Provided by",
	"Combo giảm ~": "Combo discount ~"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/i18n.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const NAMESPACE = "teko-ecommerce";
const t = (keys, options) => {
  const text = i18next["default"].t(keys, __spreadProps(__spreadValues({}, options), { ns: NAMESPACE }));
  return text || keys;
};
const lang = {
  vi: viLang,
  en: enLang
};




/***/ }),

/***/ 179185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ LazyImage; },
/* harmony export */   "x": function() { return /* binding */ WebpImage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);



const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => ({
  maxWidth: "100%",
  position: "relative",
  overflow: "hidden",
  flex: "1 0 auto",
  display: "flex",
  cursor: props.onClick ? "pointer" : "unset",
  zIndex: 0,
  margin: "auto",
  borderRadius: props.borderRadius + "px",
  paddingBottom: props.height ? "" : `${100 / props.aspectRatio}%`,
  border: props.border ? "1px solid #e0e0e0" : "",
  height: props.height ? `${props.height}px !important` : "",
  width: props.width ? `${props.width}px` : "100%",
  backgroundImage: props.thumbnail ? `url("${props.thumbnail}")` : null,
  backgroundSize: props.thumbnail ? "cover" : null,
  contentVisibility: props.height && props.width ? "auto" : null
}));
const WebpImage = ({
  src,
  onClick,
  className,
  height,
  width,
  imageWidth,
  alt = "",
  decoding = "async",
  onLoad
}) => {
  const placeHolder = "data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNjAiIGhlaWdodD0iMjYwIiB2aWV3Qm94PSIwIDAgMjYwIDI2MCI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGZpbGw9IiNGNkY2RjYiIGQ9Ik0wIDBoMjYwdjI2MEgweiIvPgogICAgICAgIDxwYXRoIGQ9Ik0xMDQgMTA0aDU0djU0aC01NHoiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjQjRCNEI0IiBkPSJNMTUxLjI1IDEwNi4yNWE0LjUgNC41IDAgMCAxIDQuNSA0LjV2NDAuNWE0LjUgNC41IDAgMCAxLTQuNSA0LjVoLTQwLjVhNC41IDQuNSAwIDAgMS00LjUtNC41di00MC41YTQuNSA0LjUgMCAwIDEgNC41LTQuNWg0MC41em0tMTMuNSAxOGwtOSAxMy41TDEyMiAxMzFsLTYuNzUgMTEuMjVoMzEuNWwtOS0xOHptLTEyLjM3NS02Ljc1YTMuMzc1IDMuMzc1IDAgMSAwIDAgNi43NSAzLjM3NSAzLjM3NSAwIDAgMCAwLTYuNzV6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
  let imageUrl = src ? src : placeHolder;
  let altImageUrl = null;
  if (imageUrl && imageUrl.includes("googleusercontent.com")) {
    if (imageWidth || width) {
      imageUrl = `${imageUrl}=w${imageWidth || width}`;
    }
    const checkExt = /=[a-z0-9-]+$/;
    altImageUrl = imageUrl;
    imageUrl = `${imageUrl}${checkExt.test(imageUrl) ? "-rw" : "=rw"}`;
  }
  const imgError = (event) => {
    if (event.target.src !== placeHolder) {
      event.target.src = placeHolder;
    }
    return;
  };
  const imgEle = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    width,
    height,
    onClick,
    className,
    alt,
    onError: imgError,
    src: imageUrl,
    loading: "lazy",
    decoding,
    onLoad
  });
  return altImageUrl ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("picture", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", {
    srcSet: imageUrl,
    type: "image/webp"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", {
    srcSet: altImageUrl,
    type: "image/png"
  }), imgEle) : imgEle;
};
const WrapperImage = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WebpImage)((props) => `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: ${props.contain ? "contain" : props.cover ? "cover" : ""};
  transition: transform 0.5s;
  &:hover {
    transform: ${props.hover === "zoom" ? "scale(1.05)" : ""};
  }
  `);
const LazyImage = ({
  src,
  onClick,
  className,
  contain = false,
  cover = false,
  aspectRatio = 1,
  height,
  width,
  alt = "",
  border = false,
  hover = "",
  borderRadius = 0,
  thumbnail,
  decoding = "async",
  imageWidth
}) => {
  const imgEle = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(WrapperImage, {
    hover,
    className: "lazyload",
    contain,
    imageWidth,
    cover,
    alt,
    "data-src": src,
    src,
    decoding
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    height,
    width,
    border,
    aspectRatio,
    borderRadius,
    onClick,
    className,
    thumbnail
  }, imgEle);
};




/***/ }),

/***/ 665207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ HeadSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(979894);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




const HeadSection = (param)=>{
    let { title , metaTitle , description , keywords , image , canonical , prevHref , nextHref , noindex =false , links  } = param;
    const { meta  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title || meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: metaTitle || title || meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: metaTitle || title || meta.title
            }),
            description !== false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description || meta.description
            }),
            keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            description !== false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description || meta.description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                content: image || meta.image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image || meta.image
            }),
            noindex ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, nofollow"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "index, follow"
            }),
            canonical && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonical
            }),
            prevHref && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "prev",
                href: prevHref
            }),
            nextHref && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "next",
                href: nextHref
            }),
            links === null || links === void 0 ? void 0 : links.map((attrs)=>Object.keys(attrs).length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", _objectSpread({}, attrs))),
            meta.dcmaVerificationContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "dmca-site-verification",
                content: meta.dcmaVerificationContent
            }),
            meta.fbDomainVerificationContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "facebook-domain-verification",
                content: meta.fbDomainVerificationContent
            })
        ]
    });
};


/***/ }),

/***/ 110413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ LazyComponent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);



function LazyComponent(param) {
    let { children , timeToRender =0  } = param;
    const ref = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    const { isBot  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useGlobalData */ .U5)();
    const { 0: hydrated , 1: setHydrated  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(isBot ? true : false);
    react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect(()=>{
        if (isBot || !ref.current) return;
        const ob = new IntersectionObserver((entries, observer)=>{
            for (const entry of entries){
                if (entry.isIntersecting) {
                    setHydrated(true);
                    observer.disconnect();
                    return;
                }
            }
        });
        ob.observe(ref.current);
        function hydrate(deadline) {
            if (deadline.timeRemaining() > timeToRender) {
                setHydrated(true);
                ob.disconnect();
            } else {
                requestIdleCallback(hydrate);
            }
        }
        if (timeToRender > 0) {
            requestIdleCallback(hydrate);
        }
        return ()=>ob.disconnect();
    }, [
        isBot,
        timeToRender
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: ref,
        className: "lazy-component",
        children: hydrated ? children : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "fake-body",
            style: {
                width: "100%",
                height: 200
            }
        })
    });
}


/***/ }),

/***/ 124177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ INLINE_BANNER_CLASSNAME; }
/* harmony export */ });
var INLINE_BANNER_CLASSNAME;
(function(INLINE_BANNER_CLASSNAME) {
    INLINE_BANNER_CLASSNAME["INLINE_HOME_TOP"] = "INLINE-HOME-TOP";
    INLINE_BANNER_CLASSNAME["INLINE_HOME_BODY"] = "INLINE-HOME-BODY";
    INLINE_BANNER_CLASSNAME["INLINE_PDP_RELATEDPROMO"] = "INLINE-PDP-RELATEDPROMO";
    INLINE_BANNER_CLASSNAME["INLINE_PDP_SERVICE"] = "INLINE-PDP-SERVICE";
    INLINE_BANNER_CLASSNAME["INLINE_PDP_PREVIEW_DESK"] = "INLINE-PDP-PREVIEW-DESK";
    INLINE_BANNER_CLASSNAME["INLINE_PDP_PREVIEW_MOBILE"] = "INLINE-PDP-PREVIEW-MOBILE";
    INLINE_BANNER_CLASSNAME["INLINE_SEARCH"] = "INLINE-SEARCH";
    INLINE_BANNER_CLASSNAME["INLINE_CATEGORY"] = "INLINE-CATEGORY";
    INLINE_BANNER_CLASSNAME["INLINE_BRAND"] = "INLINE-BRAND";
    INLINE_BANNER_CLASSNAME["INLINE_SELLER"] = "INLINE-SELLER";
    INLINE_BANNER_CLASSNAME["INLINE_CART"] = "INLINE-CART";
    INLINE_BANNER_CLASSNAME["INLINE_CHECKOUT"] = "INLINE-CHECKOUT";
})(INLINE_BANNER_CLASSNAME || (INLINE_BANNER_CLASSNAME = {}));


/***/ }),

/***/ 770353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useIsomorphicLayoutEffect; },
/* harmony export */   "w": function() { return /* binding */ useIdentifiedPage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);

const useIsomorphicLayoutEffect =  true ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : 0;
const useIdentifiedPage = (className)=>{
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const node = document.createElement("div");
        node.className = className;
        node.style.display = "none";
        document.body.prepend(node);
        return ()=>node.remove();
    }, []);
};


/***/ }),

/***/ 891080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ getBlockParams; }
/* harmony export */ });
/* unused harmony export getServerSidePropsBlockPage */
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(420577);
/* harmony import */ var _teko_discovery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(875663);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




const getBlockParams = (query)=>{
    let blockParams = {
        pageTypeEnum: _teko_discovery__WEBPACK_IMPORTED_MODULE_1__/* .PageTypeEnum.CATEGORY */ .DZ.CATEGORY
    };
    const { categoryId , sellerId , brandId , sellerCategoryId  } = query;
    if (categoryId) {
        blockParams = {
            pageTypeEnum: _teko_discovery__WEBPACK_IMPORTED_MODULE_1__/* .PageTypeEnum.CATEGORY */ .DZ.CATEGORY,
            category: categoryId
        };
    } else if (sellerId) {
        blockParams = {
            pageTypeEnum: _teko_discovery__WEBPACK_IMPORTED_MODULE_1__/* .PageTypeEnum.SELLER */ .DZ.SELLER,
            seller: sellerId
        };
    } else if (brandId) {
        blockParams = {
            pageTypeEnum: _teko_discovery__WEBPACK_IMPORTED_MODULE_1__/* .PageTypeEnum.BRAND */ .DZ.BRAND,
            brand: brandId
        };
    } else if (sellerCategoryId) {
        blockParams = {
            pageTypeEnum: _teko_discovery__WEBPACK_IMPORTED_MODULE_1__/* .PageTypeEnum.CATEGORY */ .DZ.CATEGORY,
            sellerCategory: sellerCategoryId
        };
    }
    return blockParams;
};
const getServerSidePropsBlockPage = async (context)=>{
    const query = context.query;
    const { tenantEnv , isMobile  } = context.req;
    const { discoveryService  } = new ServiceContainer(tenantEnv);
    // Logic auto gen slug can be found in: shop-front/helpers/index.ts > buildSlugUrl
    let canonical = "";
    const blockParams = getBlockParams(query);
    const { brandId  } = query;
    const activeSortOption = getActiveSortOption(query, tenantEnv.sortByCreatedAt, tenantEnv.defaultSortOptionCode);
    const [sort, order] = activeSortOption ? extractSortQuery(activeSortOption.optionCode) : [
        undefined,
        undefined
    ];
    try {
        var ref, ref1, ref2, ref3, ref4;
        const data = await discoveryService.getBlock(_objectSpread({}, blockParams));
        const blocks = (data === null || data === void 0 ? void 0 : (ref = data.result) === null || ref === void 0 ? void 0 : (ref1 = ref.blocks) === null || ref1 === void 0 ? void 0 : ref1.map(transformBlock)) || [];
        // Override canonical
        if (data === null || data === void 0 ? void 0 : (ref2 = data.result) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.seoInfo) === null || ref3 === void 0 ? void 0 : ref3.canonical) {
            var ref5, ref6;
            canonical = data === null || data === void 0 ? void 0 : (ref5 = data.result) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.seoInfo) === null || ref6 === void 0 ? void 0 : ref6.canonical;
        }
        if (!canonical && !!brandId) {
            // set canonical to only path of the current request
            // ignore query parameters
            canonical = "/".concat(brandId, "-brand.").concat(brandId);
        }
        const serverData = {
            blocks: blocks || [],
            seoInfo: (data === null || data === void 0 ? void 0 : (ref4 = data.result) === null || ref4 === void 0 ? void 0 : ref4.seoInfo) ? _objectSpreadProps(_objectSpread({}, data === null || data === void 0 ? void 0 : data.result.seoInfo), {
                canonical
            }) : {}
        };
        // handle default template
        // which would include 2 blocks MAIN_SKU_LIST && LIST_SKU_MOBILE
        if (blocks.length === 2 && blocks.find((b)=>b.type === BlockType.MAIN_SKU_LIST) && blocks.find((b)=>b.type === BlockType.LIST_SKU_MOBILE)) {
            // SSR filter block for desktop default template
            if (!isMobile) {
                var ref7;
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const mainSkuBlock = blocks.find((b)=>b.type === BlockType.MAIN_SKU_LIST);
                const resp = await fetchSingleDataBlockSSRFromDiscoveryV2(context, mainSkuBlock, true, {
                    sort,
                    order
                });
                if (!((ref7 = resp.ssrProducts) === null || ref7 === void 0 ? void 0 : ref7.length)) {
                    return {
                        notFound: true
                    };
                }
                return {
                    props: _objectSpreadProps(_objectSpread({}, serverData), {
                        mapSSRProducts: {
                            [mainSkuBlock.id]: resp.ssrProducts
                        },
                        cookedFilters: resp.cookFilters || null,
                        filters: resp.filters || null,
                        filterPrice: resp.filterPrice || null
                    })
                };
            } else {
                var ref8;
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const listSkuMobile = blocks.find((b)=>b.type === BlockType.LIST_SKU_MOBILE);
                const res = await fetchSingleDataBlockSSRFromDiscoveryV2(context, listSkuMobile, false, {
                    sort,
                    order
                });
                // count the number of products and return 404 if it has nothing
                if (!((ref8 = res.ssrProducts) === null || ref8 === void 0 ? void 0 : ref8.length)) {
                    return {
                        notFound: true
                    };
                }
                return {
                    props: _objectSpreadProps(_objectSpread({}, serverData), {
                        mapSSRProducts: {
                            [listSkuMobile.id]: res.ssrProducts || []
                        }
                    })
                };
            }
        }
        const res1 = await fetchDataBlockSSRFromDiscoveryV2(context, blocks);
        return {
            props: _objectSpreadProps(_objectSpread({}, serverData), {
                mapSSRProducts: res1 || {}
            })
        };
    } catch (e) {
        logger.error(context.req, e);
        return {
            props: {
                blocks: [],
                cookedFilters: []
            }
        };
    }
};


/***/ }),

/***/ 77322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ trackViewProductDetail; },
/* harmony export */   "u": function() { return /* binding */ trackViewProductList; }
/* harmony export */ });
/* harmony import */ var _meta_pixel_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(437618);


const trackViewProductDetail = (product) => {
  var _a, _b;
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: "viewDetail",
    ecommerce: {
      detail: {
        products: [product]
      }
    }
  });
  if (!!window.fbq && !!((_b = window.env) == null ? void 0 : _b.FB_PIXEL_ID)) {
    const value = typeof product.price === "number" ? product.price : parseFloat(product.price) || 0;
    (0,_meta_pixel_es_js__WEBPACK_IMPORTED_MODULE_0__/* .trackMetaPixelViewContent */ .SI)({
      content_ids: [product.sku],
      content_category: product.category || "",
      content_name: product.name || "",
      content_type: "product",
      contents: [{ id: product.sku, quantity: 1 }],
      currency: "VND",
      value
    });
  }
};
const trackViewProductList = (products) => {
  var _a;
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: "viewListing",
    ecommerce: {
      impressions: products
    }
  });
};




/***/ })

}]);